<template>
  <svg
    class="custom-icon"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.00817537 5.3099C0.007631 4.03447 0.525511 2.81104 1.448 1.9088C2.37031 1.00679 3.62163 0.5 4.92628 0.5C6.23056 0.5 7.48151 1.00643 8.40382 1.90812C9.32612 2.80977 9.84439 4.0327 9.84439 5.30795V6.84572C9.84439 6.89841 9.82298 6.94896 9.78487 6.98622C9.74677 7.02347 9.69505 7.0444 9.64116 7.0444H7.68C7.56768 7.0444 7.47678 6.95535 7.47678 6.84572V5.3099C7.47678 4.64789 7.20841 4.01286 6.73029 3.54398C6.25216 3.07515 5.60346 2.81068 4.92628 2.80854C4.24766 2.80854 3.59696 3.07214 3.11702 3.54117C2.63727 4.01036 2.36761 4.64649 2.36761 5.3099V6.84768C2.36761 6.90036 2.3462 6.95091 2.3081 6.98817C2.26999 7.02542 2.21828 7.04635 2.16438 7.04635H0.203228C0.0910878 7.04635 0 6.9573 0 6.84768L0.00817537 5.3099Z"
    />
    <path
      d="M5.4 8.57808V14.5384C5.4 14.7934 5.50361 15.0379 5.68815 15.2183C5.87251 15.3987 6.12273 15.5 6.38367 15.5H17.0124C17.2731 15.5011 17.5239 15.4007 17.709 15.2211C17.8942 15.0416 17.9989 14.7974 18 14.5423V8.58201C18 8.3271 17.8964 8.08248 17.7119 7.90206C17.5275 7.72183 17.2773 7.62055 17.0163 7.62055H6.38764C6.12689 7.61948 5.87611 7.71971 5.69105 7.89922C5.50579 8.07892 5.40109 8.323 5.4 8.57808Z"
    />
  </svg>
</template>
